// extracted by mini-css-extract-plugin
export default {"logo":"Redirect_logo__oAQuQ","checkLogo":"Redirect_checkLogo__RKriE","successHeader":"Redirect_successHeader__ioZfP","successMessage":"Redirect_successMessage__2TGRC"};